import { SVGAttributes } from 'react'

const StarIcon = (props: SVGAttributes<SVGElement>) => (
    <svg
        fill={props.color || 'white'}
        width="31"
        height="32"
        viewBox="0 0 31 32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M8.79653 27.3591C7.19421 28.1467 6.14342 27.4328 6.44904 25.7651L7.73476 18.7576L2.28878 13.7951C0.992457 12.6138 1.39386 11.4592 3.18509 11.2159L10.7118 10.1932L14.0778 3.81788C14.8789 2.30029 16.1778 2.30029 16.979 3.81788L20.3447 10.1932L27.8714 11.2159C29.6628 11.4593 30.0641 12.6139 28.768 13.7951L23.322 18.7578L24.608 25.7653C24.9138 27.433 23.8629 28.1466 22.2606 27.3593L15.5286 24.0508L8.79653 27.3591Z" />
    </svg>
)

export default StarIcon
